<script setup>
import { ref, onMounted, toRefs } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  categoryList: {
    type: Array,
    default: () => []
  }
})
const { categoryList } = toRefs(props)

const searchInfo = ref({
  name: '',
  ubn: '',
  category: ''
})

const supplierCategoryList = categoryList.value.map(([label, value]) => ({
  value,
  label
}))

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.name = searchParams.get('name')
  searchInfo.value.ubn = searchParams.get('ubn')
  searchInfo.value.category = searchParams.get('category')
})
</script>

<template>
  <form class="min-w-[248px] p-4" action="/settings/suppliers" accept-charset="UTF-8" method="get">
    <div class="mb-2">
      <BaseTextInput :label="'中文名稱'" :name="'name'" v-model="searchInfo.name"></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseTextInput :label="'統編'" :name="'ubn'" v-model="searchInfo.ubn"></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'類型'"
        :name="'category'"
        :optionList="supplierCategoryList"
        :optionsSelected="searchInfo.category"
        @select="searchInfo.category = $event"
      />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a href="/settings/suppliers" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
<style scoped>
.anticon {
  display: inline-flex;
}
</style>
